import * as _ from 'lodash';
import { OrganPackaging } from '@nkr/store/index';

interface IValidation {
    organPackaging: { field: string, message: string },
    achRoutingNumber: { field: string, message: string },
    achAccountNumber: { field: string, message: string },
    selectedOpo: { field: string, message: string }
}

const initialValidation: IValidation = {
    organPackaging: { field: 'Organ Packaging', message: '' },
    achRoutingNumber: { field: 'ACH Routing Number', message: '' },
    achAccountNumber: { field: 'ACH Account Number', message: '' },
    selectedOpo: { field: 'Selected OPO', message: '' }
};

interface IState {
    organPackaging: OrganPackaging,
    achRoutingNumber: string,
    achAccountNumber: string,

    originalAchRoutingNumber: string,
    originalAchAccountNumber: string,

    selectedOpo: number,

    hashValue: string,
    validation: IValidation
}

const initialState: IState = {
    organPackaging: OrganPackaging.InHouse,
    achRoutingNumber: '',
    achAccountNumber: '',

    originalAchRoutingNumber: '',
    originalAchAccountNumber: '',

    selectedOpo: 0,

    hashValue: '',
    validation: _.cloneDeep(initialValidation)
};

type Action =
    | { type: 'initialize', payload: IState }
    | { type: 'updateField', payload: { name: string, value: any } }
    | { type: 'updateValidation', payload: IValidation }
    | { type: 'updateHash', payload: string };

const reducer = (state: IState, action: Action): IState => {
    switch (action.type) {
        case 'initialize':
            return { ...action.payload };

        case 'updateField':
            let newState = { ...state, [action.payload.name]: action.payload.value };

            if (action.payload.name == 'organPackaging') {
                if (newState.organPackaging == OrganPackaging.InHouse) {
                    newState.selectedOpo = 0;
                } else if (newState.organPackaging == OrganPackaging.Opo) {
                    // newState.achRoutingNumber = '';
                    // newState.achAccountNumber = '';
                }

                newState = { ...newState, validation: initialValidation };
            }

            return newState;

        case 'updateValidation':
            return { ...state, validation: action.payload };

        case 'updateHash':
            return { ...state, hashValue: action.payload };

        default:
            return { ...state };
    }
}

export { initialState, initialValidation, reducer };
